import { render, staticRenderFns } from "./addNotice.vue?vue&type=template&id=7fa34cec&scoped=true"
import script from "./addNotice.vue?vue&type=script&lang=js"
export * from "./addNotice.vue?vue&type=script&lang=js"
import style0 from "./addNotice.vue?vue&type=style&index=0&id=7fa34cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa34cec",
  null
  
)

export default component.exports